/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".collection-card[_ngcontent-%COMP%]{display:inline-block;width:184px;height:184px;border-radius:8px;box-shadow:0 0 8px 0 rgba(0,0,0,.2)}"];
export { styles as styles };
